
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[storySlug]",
      function () {
        return require("private-next-pages/stories/[storySlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/[storySlug]"])
      });
    }
  